"use client";
import { createContext, useState, useContext, ReactNode } from "react";
export type UserConf ={
    user: {
        codeApplication: string|  null;
        codeModule: string|  null;
        user_code: string|  null;
        id: string|  null;
        isConnected: Boolean|  null;
        password: string;
        site: {
            sit_couleur: null
            sit_id: number|  null;
            sit_nom: string|  null;
            soc_id: number|  null;
            soc_nom: string|  null;
            v_ordre: string|  null;
        }

        subscriber: string|  null;
        typeConnexion: string|  null;
        url: string|  null;
    }
}
export type ConfAccount = {
    conf: {
        authenticated: {
            u_id: string |  null;
            u_group_code: string|  null;
            u_nom: string|  null;
            u_admin: boolean|  null;
            u_perm: string|  null;
            u_couleur: string|  null;
            u_desactive: boolean|  null;
            s_email: string|  null;
            app_nom: boolean|  null;
            mod_id: string|  null;
            mod_code: string|  null;
            mod_lib: string|  null;
            auth_ok: boolean|  null;
            connexion_ok: boolean|  null;
            acces_ok: boolean|  null;
        }
        ifOffLineMode: boolean;
    }
    token: string|  null;
    user: {
        codeApplication: string|  null;
        codeModule: string|  null;
        user_code: string|  null;
        id: string|  null;
        isConnected: boolean;
        password: string;
        site: {
            sit_couleur: null
            sit_id: number|  null;
            sit_nom: string|  null;
            soc_id: number|  null;
            soc_nom: string|  null;
            v_ordre: string|  null;
        }

        subscriber: string|  null;
        typeConnexion: string|  null;
        url: string|  null;
    }
};

export type ConfContextType = {
    conf: ConfAccount;
    setConf: React.Dispatch<React.SetStateAction<ConfAccount>>;
};
const ConfContext = createContext<ConfContextType | undefined>(undefined);
export const ConfProvider: React.FC<{
    children?: ReactNode;
}> = ({ children }) => {
    const [conf, setConf] = useState<ConfAccount>({
        conf: {
            authenticated: {
                u_id: "",
                u_group_code: "",
                u_nom: "",
                u_admin: false,
                u_perm: "",
                u_couleur: "",
                u_desactive: false,
                s_email: "",
                app_nom: false,
                mod_id: "",
                mod_code: "",
                mod_lib: "",
                auth_ok: false,
                connexion_ok: false,
                acces_ok: false,
            },
            ifOffLineMode: false,
        },
        token: "",
        user: {
            codeApplication: "",
            codeModule: "",
            user_code: "",
            id: "",
            isConnected: false,
            password: "",
            site: {
                sit_couleur: null,
                sit_id: null,
                sit_nom: "",
                soc_id: null,
                soc_nom: "",
                v_ordre: "",
            },
            subscriber: "",
            typeConnexion: "",
            url: "",
        },
    });
    return (
        <ConfContext.Provider value={{ conf, setConf }}>
            {children}
        </ConfContext.Provider>
    );
};
export const useConf = () => {
    const context = useContext(ConfContext);
    if (!context) {
        throw new Error("Erreur Context User");
    }
    return context;
};
